/**
 * @param this vue this 바인딩
 * @param object link
 * @param object link.link - string
 * @description link.link의 origin을 제외한 부분의 url을 사용. 내부 라우팅 방식.
 * @author jaehyub.lee
 */
import { NavigateFunction } from 'react-router-dom';

import { paths } from 'src/routes/paths';

import { storageConstants } from './constants/storageConstants';

// Define types for the item parameter
interface Link {
  link: string;
  connection: {
    staticPath: {
      code: string;
    };
  };
}

enum StaticPath {
  MAIN_PAGE = 'MAIN_PAGE',
  EXTERNAL_PAGE = 'EXTERNAL_PAGE',
}

interface Item {
  link: Link;
}

export const moveRouterLink = (moveNavigate: NavigateFunction, item: Item) => {
  if (!item?.link?.link) {
    return console.log('공유링크가 없습니다. ', item);
  }

  const { link, connection } = item.link;
  const isExternalLink = connection.staticPath.code === StaticPath.EXTERNAL_PAGE;
  const isMainPage = connection.staticPath.code === StaticPath.MAIN_PAGE;

  if (isExternalLink) {
    window.location.href = link;
    return undefined;
  }

  if (isMainPage) {
    return moveNavigate(paths.home);
  }

  const moveLink = link.replace(localStorage.getItem(storageConstants.vueAppPaymentHost) ?? '', '');
  console.log('moveLink', moveLink);
  if (moveLink) {
    return moveNavigate(moveLink);
  }

  return undefined;
};
